import { render, staticRenderFns } from "./AnalisysStep2New.vue?vue&type=template&id=5a2a7913&"
import script from "./AnalisysStep2New.vue?vue&type=script&lang=js&"
export * from "./AnalisysStep2New.vue?vue&type=script&lang=js&"
import style0 from "./AnalisysStep2New.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports